import { useEffect, useState } from "react";
import ChessButton from "../../visual/ChessButton/ChessButton";
import useSoundEffect from "../../../hooks/useSoundEffect";
import { setActiveRow, setActiveCol, KeyCodes } from "../../../utils/navigationHelpers";
import "./PuzzleComplete.scss";
import { useMultiplayer } from "../../../context/MultiplayerContext";
import PuzzleCalendar from "../PuzzleCalendar/PuzzleCalendar";

interface PuzzleCompleteProps {
    onClose: () => void;
}

/**
 * PuzzleComplete component
 * Celebration modal shown when player successfully completes a puzzle
 * @param onClose - Function to close the modal
 */
export default function PuzzleComplete({ onClose }: PuzzleCompleteProps) {
    const { playClickAudio } = useSoundEffect();
    const { handleReturnMainMenu } = useMultiplayer();
    const [showCalendar, setShowCalendar] = useState(false);

    // Set focus on the close button when modal opens
    useEffect(() => {
        setActiveRow(0);
        setActiveCol(0);
    }, []);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (KeyCodes.Ups.includes(event.key) || KeyCodes.Downs.includes(event.key)) {
                playClickAudio();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [playClickAudio]);

    return (
        <>
            {showCalendar && <PuzzleCalendar onClose={() => setShowCalendar(false)} />}
            <div className="puzzle-complete" data-testid="puzzle-complete">
                <div className="puzzle-complete-content">
                    <div className="puzzle-complete-icon">🎉</div>
                    <h1>Puzzle Solved!</h1>
                    <p className="puzzle-complete-message">
                        Congratulations! You&apos;ve successfully completed this puzzle!
                    </p>
                    <div className="puzzle-complete-buttons">
                        <ChessButton data-navrow={0} data-navcol={0} autoFocus onClick={onClose}>
                            View Board
                        </ChessButton>
                        <ChessButton
                            data-navcol={0}
                            data-navrow={1}
                            onClick={() => {
                                setShowCalendar(true);
                            }}
                        >
                            Puzzle Calendar
                        </ChessButton>
                        <ChessButton
                            data-navcol={0}
                            data-navrow={2}
                            onClick={() => {
                                handleReturnMainMenu();
                            }}
                        >
                            Main Menu
                        </ChessButton>
                    </div>
                </div>
            </div>
        </>
    );
}
